export default {"src":"/_next/static/media/discourse_icon.4962c291.svg","height":88,"width":88,"blurWidth":0,"blurHeight":0};